import React from 'react'
import CustomCursor from '../../Global/Cursor'
import Preloder from '../../Global/Preloader'
import Header_3 from '../../Global/Header3'
import Banner from '../MenHomeThree/Banner'
import About from '../MenHomeThree/About'
import Service from '../MenHomeThree/Service'
import Testimonial from '../MenHomeThree/Testimonial'
import Team from '../MenHomeThree/Team'
import WhyChouse from '../MenHomeThree/WhyChouse'
import Portfilo from '../MenHomeThree/Portfilo'
import Blog from '../MenHomeThree/Blog'
import Footer3 from '../../Global/Footer3'
import GoToTop from '../../Global/GoToTop'

const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloder />
            <Header_3 />
            <Banner />
            <About />
            <Service />
            <Testimonial />
            <Team />
            <WhyChouse />
            <Portfilo />
            <Blog />
            <Footer3 />
            <GoToTop />
        </>
    )
}

export default Main
